export const initOpts = { renderer: 'canvas', devicePixelRatio: 2 }